import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { BaseComponent } from "./layout/base/base.component";
import { LayoutModule } from "./layout/layout.module";
import { FormsModule } from "@angular/forms";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from "@angular/common/http";
import { NgxDropzoneModule } from 'ngx-dropzone';
import { RequestComponent } from "./Components/request/request.component";
import { AgencyHomeComponent, AgencyHomeDialogComponent } from "./Components/agency-home/agency-home.component";
import { HomeComponent } from "./Components/home/home.component";
import { ContextFormComponent } from "./Components/context-form/context-form.component";
import { AgencyOverviewComponent } from './Components/request/agency-overview/agency-overview.component';
import { AgencyIdentificationComponent } from './Components/request/agency-identification/agency-identification.component';
import { LegalRepresentativeComponent } from './Components/request/legal-representative/legal-representative.component';
import { AgencyLocationComponent } from './Components/request/agency-location/agency-location.component';
import { ConsultDocumentDialogComponent, DocumentComponent, DocumentDialogComponent } from './Components/document/document.component';
import { AttachmentV2Component } from "./attachment/attachment.componentV2";
import { AttachmentComponent } from "./attachment/attachment.component";
import { AgencyBeneficiariesDialogComponent, AgencyPartnersComponent, AgencyPartnersDialogComponent } from './Components/request/agency-partners/agency-partners.component';
import { AgencySignaturesComponent } from './Components/request/agency-signatures/agency-signatures.component';
import { AgencySignaturesDialogComponent } from "./Components/request/agency-signatures/agency-signatures.component";
import { ConsultConnectionDocumentsComponent } from './Components/consult-connection-documents/consult-connection-documents.component';
import { AgencyRegisterComponent } from "./AgencyRegister.component";
import { FooterComponent } from "./layout/footer/footer.component";
import { HeaderComponent } from "./layout/header/header.component";
import { AcceptTermsComponent } from './Components/accept-terms/accept-terms.component';
import { TrainingComponent } from './Components/training/training.component';

import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import {MatMenuModule} from '@angular/material/menu';
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatStepperModule } from "@angular/material/stepper";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import {MatTableModule} from '@angular/material/table';
import { MatChipsModule } from "@angular/material/chips";
import {MatRadioModule} from '@angular/material/radio';
import {MatTabsModule} from '@angular/material/tabs';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

import { MyMessagesComponent } from './Components/my-messages/my-messages.component';
import { LearnmoreComponent } from './Components/learnmore/learnmore.component';
import { ConsultConnectionDataComponent } from './Components/consult-connection-data/consult-connection-data.component';
import { AccessRequestComponent } from './Components/access-request/access-request.component';
import { LearnmorePlanRegistrationComponent } from './Components/learnmore-plan-registration/learnmore-plan-registration.component';
import { LearnmoreFormDataComponent } from './Components/learnmore-form-data/learnmore-form-data.component';
import { AgencyNuevaComponent } from './Components/agency-nueva/agency-nueva.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {MatDividerModule} from '@angular/material/divider';

import { AgencyAviancaPoliciesComponent, AgencyEntityTypeComponent, AgencyInfoComponent, AgencyInterestConflictComponent, AgencyPoliticExposedComponent, AgencyTermsConditionsComponent, EthicsComplianceComponent } from './Components/ethics-compliance/ethics-compliance.component';
import { AgencyPolicyComponent } from './Components/agency-policy/agency-policy.component';
import { ExtraWarrantyComponent } from './Components/extra-warranty/extra-warranty.component';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { AgencyAccessLetterComponent } from './Components/request/agency-access-letter/agency-access-letter.component';
import { ApplicationApprovalComponent } from "./Components/application-approval/application-approval.component";
import { StatusUpdateMessageComponent } from './Components/status-update-message/status-update-message.component';
import { AgencyUpdateComponent, AgencyUpdatePartnersDialogComponent } from "./Components/agency-update/agency-update.component";
import { AgencyLegalComponent } from "./Components/agency-legal/agency-legal.component";
import { AgencyLegalDocumentComponent } from "./Components/agency-legal-document/agency-legal-document.component";
import { ContractsComponent } from "./Components/contracts/contracts.component";
import { TerminationLetterComponent } from './Components/Termination-Letter/termination-letter/termination-letter.component';
import { HollidayModuleComponent } from './Components/holliday-module/holliday-module.component';
import { AgencyPortalAdminComponent } from "./Components/request/agency-portal-admin/agency-portal-admin.component";

export function CreateTranslateLoader(http: HttpClient){
  return  new TranslateHttpLoader(http,"./assets/i18n/AgencyRegister/",".json");
  }

const routes: Routes = [
  {
    path: "Main",
    component: BaseComponent,
    children: [
      {
        path: "Document",
        redirectTo: "Document",
        pathMatch: "full",
      },
      {
        path: "Document/:requestcode",
        redirectTo: "Document/:requestcode",
        pathMatch: "full",
      },
      {
        path: "ConsultConnectionData",
        redirectTo: "ConsultConnectionData",
        pathMatch: "full",
      },
      {
        path: "ConsultConnectionData/:requestcode",
        redirectTo: "ConsultConnectionData/:requestcode",
        pathMatch: "full",
      },
      {
        path: "ConsultConnectionDocuments",
        redirectTo: "ConsultConnectionDocuments",
        pathMatch: "full",
      },
      {
        path: "ConsultConnectionDocuments/:requestcode",
        redirectTo: "ConsultConnectionDocuments/:requestcode",
        pathMatch: "full",
      },
      {
        path: "",
        redirectTo: "Request",
        pathMatch: "full",
      },
      {
        path: "AcceptTerms",
        redirectTo: "AcceptTerms",
        pathMatch: "full",
      },
      {
        path: "training",
        redirectTo: "training",
        pathMatch: "full",
      },
      {
        path: "training/:requestcode",
        redirectTo: "training/:requestcode",
        pathMatch: "full",
      },
      {
        path: "LearnMore",
        redirectTo: "LearnMore",
        pathMatch: "full",
      },
      {
        path: "LearnMore/:type",
        redirectTo: "LearnMore/:type",
        pathMatch: "full",
      },
      {
        path: "Document",
        component: DocumentComponent,
      },
      {
        path: "Document/:requestcode",
        component: DocumentComponent,
      },
      {
        path: "ApplicationApproval",
        component: ApplicationApprovalComponent,
      },
      {
        path: "ApplicationApproval/:requestcode",
        component: ApplicationApprovalComponent,
      },
      {
        path: "ConsultConnectionData",
        component: ConsultConnectionDataComponent,
      },
      {
        path: "ConsultConnectionData/:requestcode",
        component: ConsultConnectionDataComponent,
      },
      {
        path: "ConsultConnectionDocuments",
        component: ConsultConnectionDocumentsComponent,
      },
      {
        path: "ConsultConnectionDocuments/:requestcode",
        component: ConsultConnectionDocumentsComponent,
      },
      {
        path: "Request",
        component: RequestComponent,
      },
      {
        path: "Request/:requestcode",
        component: RequestComponent,
      },
      {
        path: "AcceptTerms",
        component: AcceptTermsComponent,
      },
      {
        path: "AcceptTerms/:requestcode",
        component: AcceptTermsComponent,
      },
      {
        path: "training",
        component: TrainingComponent,
      },
      {
        path: "training/:requestcode",
        component: TrainingComponent,
      },
      {
        path: "MyMessages",
        component: MyMessagesComponent,
      },
      {
        path: "LearnMore",
        component: LearnmoreComponent,
      },
      {
        path: "LearnMore/:type",
        component: LearnmoreComponent,
      },
      {
        path: "LearnMorePlanRegistration",
        component: LearnmorePlanRegistrationComponent,
      },
      {
        path: "LearnMorePlanRegistration/:type",
        component: LearnmorePlanRegistrationComponent,
      },
      {
        path: "LearnMoreFormData",
        component: LearnmoreFormDataComponent,
      },
      {
        path: "LearnMoreFormData/:type",
        component: LearnmoreFormDataComponent,
      },
      {
        path: "AccessRequest",
        component: AccessRequestComponent,
      },
      {
        path: "AgencyPolicy",
        component: AgencyPolicyComponent,
      },
      {
        path: "AgencyExtraWarranty",
        component: ExtraWarrantyComponent,
      },
      {
        path: "StatusUpdateMessage",
        component: StatusUpdateMessageComponent,
      },
      {
        path: "StatusUpdateMessage/:id",
        component: StatusUpdateMessageComponent,
      },
      {
        path: "TerminationLetter/:id",
        component: TerminationLetterComponent,
      },
      {
        path: "AgencyUpdate",
        component: AgencyUpdateComponent,
      },
      {
        path: "AgencyUpdate/:iata",
        component: AgencyUpdateComponent,
      },
      {
        path: "AgencyLegal",
        component: AgencyLegalComponent,
      },
      {
        path: "AgencyLegal/:id",
        component: AgencyLegalComponent,
      },
      {
        path: "AgencyLegalDocument",
        component: AgencyLegalDocumentComponent,
      },
      {
        path: "AgencyLegalDocument/:id",
        component: AgencyLegalDocumentComponent,
      },
      {
        path: "TermsRepository/:iata/:name/:email",
        component: ContractsComponent,
        children: [
        ]
      }
    ],
  },
  {
    path: "",
    component: AgencyRegisterComponent,
  },
  {
    path: "Home",
    component: HomeComponent,
    children: [
    ]
  },
  {
    path: "AgencyHome",
    component: AgencyHomeComponent,
    children: [
    ]
  },
  {
    path: "LearnMorePlanRegistration",
    component: LearnmorePlanRegistrationComponent,
  },
  {
    path: "LearnMoreFormData",
    component: LearnmoreFormDataComponent,
  },
  {
    path: "LearnMore",
    component: LearnmoreComponent,
  },
  {
    path: "EthicsCompliance",
    component: EthicsComplianceComponent,
  }

];

@NgModule({
  imports: [
    LayoutModule,
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    NgbModule,
    MatDividerModule,
    TranslateModule.forRoot({
      loader:{
        provide: TranslateLoader,
        useFactory:CreateTranslateLoader,
        deps:[HttpClient]
      }
    }),
    NgxDropzoneModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatStepperModule,
    MatCardModule,
    MatSidenavModule,
    MatListModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatDialogModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatGridListModule,
    MatTableModule,
    MatRadioModule,
    MatCheckboxModule,
    MatMenuModule,
    MatChipsModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule
  ],
  exports:[
    TranslateModule,
    AgencyAviancaPoliciesComponent,
    AgencyEntityTypeComponent,
    AgencyInfoComponent,
    AgencyInterestConflictComponent,
    AgencyPoliticExposedComponent,
    AgencyTermsConditionsComponent,
    EthicsComplianceComponent
  ],
  entryComponents: [
    DocumentDialogComponent,
    AgencyPortalAdminComponent,
    AgencyPartnersDialogComponent,
    AgencyBeneficiariesDialogComponent,
    AgencySignaturesDialogComponent,
    ConsultDocumentDialogComponent,
    AgencyInfoComponent,
    AgencyEntityTypeComponent,
    AgencyAviancaPoliciesComponent,
    AgencyPoliticExposedComponent,
    AgencyInterestConflictComponent,
    AgencyTermsConditionsComponent,
    AgencyUpdatePartnersDialogComponent
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    RequestComponent,
    AgencyHomeComponent,
    AgencyHomeDialogComponent,
    AgencyRegisterComponent,
    /* MainComponent, */
    ContextFormComponent,
    AgencyOverviewComponent,
    AgencyIdentificationComponent,
    LegalRepresentativeComponent,
    AgencyLocationComponent,
    DocumentComponent,
    AttachmentComponent,
    DocumentDialogComponent,
    AgencyPortalAdminComponent,
    AgencyPartnersComponent,
    AgencyPartnersDialogComponent,
    AgencyBeneficiariesDialogComponent,
    AgencyInfoComponent,
    AgencyEntityTypeComponent,
    AgencyAviancaPoliciesComponent,
    AgencyPoliticExposedComponent,
    AgencyInterestConflictComponent,
    AgencyTermsConditionsComponent,
    AgencySignaturesComponent,
    AgencySignaturesDialogComponent,
    AttachmentV2Component,
    DocumentDialogComponent,
    ConsultDocumentDialogComponent,
    ConsultConnectionDocumentsComponent,
    AcceptTermsComponent,
    TrainingComponent,
    MyMessagesComponent,
    LearnmoreComponent,
    ConsultConnectionDataComponent,
    AccessRequestComponent,
    LearnmorePlanRegistrationComponent,
    LearnmoreFormDataComponent,
    AgencyNuevaComponent,
    EthicsComplianceComponent,
    AgencyPolicyComponent,
    ExtraWarrantyComponent,
    AgencyAccessLetterComponent,
    ApplicationApprovalComponent,
    StatusUpdateMessageComponent,
    AgencyUpdateComponent,
    AgencyUpdatePartnersDialogComponent,
    AgencyLegalComponent,
    AgencyLegalDocumentComponent,
    ContractsComponent,
    TerminationLetterComponent,
    HollidayModuleComponent
  ],
})
export class AgencyRegisterModule {}
